import { render, staticRenderFns } from "./Tornado.vue?vue&type=template&id=ffec9ae0&scoped=true"
import script from "./Tornado.vue?vue&type=script&lang=js"
export * from "./Tornado.vue?vue&type=script&lang=js"
import style0 from "./Tornado.vue?vue&type=style&index=0&id=ffec9ae0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffec9ae0",
  null
  
)

export default component.exports